import { render } from "./StickerEditor.vue?vue&type=template&id=47b58ae3&scoped=true"
import script from "./StickerEditor.vue?vue&type=script&scope=true&lang=js"
export * from "./StickerEditor.vue?vue&type=script&scope=true&lang=js"

import "./StickerEditor.vue?vue&type=style&index=0&id=47b58ae3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b58ae3"]])

export default __exports__